import { FileMetadata } from "@domain/schemas/BI";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { TYPES } from "@utils/inversifyJS/types";
import axios from "axios";
import { inject, injectable } from "inversify";

@injectable()
export class ArchiveRepository {
  private readonly baseUrl = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.archives}`;

  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async getJobArchives(jobCreatedAt: string, jobName: string, jobAnalysisName?: string): Promise<FileMetadata[]> {
    const parameters = new URLSearchParams();
    parameters.append("jobCreatedAt", jobCreatedAt);
    parameters.append("jobName", jobName);
    if (jobAnalysisName) {
      parameters.append("jobAnalysisName", jobAnalysisName);
    }

    const url = `${this.baseUrl}?${parameters.toString()}`;
    return this._requestHandlerService.handleRequestAsync<FileMetadata[]>(() => axios.get<FileMetadata[]>(url));
  }

  public async getArchiveCandidateJobs(): Promise<ArchiveCandidateJob[]> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.archivesJobs}`;
    return this._requestHandlerService.handleRequestAsync<ArchiveCandidateJob[]>(() => axios.get<ArchiveCandidateJob[]>(url));
  }
}

export interface ArchiveCandidateJob {
  id: string;
  name: string;
  analysisName: string;
  createdAt: string;
  archivesPath: string;
}
